<!-- <ion-content appScrollbarTheme >
  <div class="langugage-popup">
    <div class="card-body p-0">
      <ion-list>

          <ion-list-header>
            <ion-label>Choose Language</ion-label>
          </ion-list-header>

          <ion-item *ngFor="let lang of languages" lines="none">
            <ion-icon name="checkmark-circle-outline" class="language-selected" *ngIf="language === lang.id" ></ion-icon>
            <ion-label (click)="selectLanguage(lang)">{{lang?.regional}} ({{lang?.name}})</ion-label>
          </ion-item>

      </ion-list>
    </div>
  </div>
</ion-content> -->
<!-- <button
  class="lang-btn"
  [matMenuTriggerFor]="menu"
  aria-label="Example icon-button with a menu"
>
  <span class="select-field accessibility-plugin-ac"
    >{{ currentSelectedValue }} <span class="icon-arrow_drop_down"></span
  ></span>
</button>
<mat-menu #menu="matMenu">
  <button
    class="accessibility-plugin-ac"
    *ngFor="let lang of languages"
    mat-menu-item
    (click)="selectLanguage(lang)"
  >
    <span class="accessibility-plugin-ac" *ngIf="lang?.name == 'English'">{{
      lang?.regional
    }}</span>
    <span class="accessibility-plugin-ac" *ngIf="lang?.name != 'English'"
      >{{ lang?.regional }} ({{ lang?.name }})</span
    >
  </button>
</mat-menu> -->

<div class="headermatSelect">
  <mat-form-field>
    <span class="labelClass accessibility-plugin-ac"
      >{{ currentSelectedValue }} <span class="icon-arrow_drop_down"></span
    ></span>
    <mat-select class="accessibility-plugin-ac">
      <mat-option *ngFor="let lang of languages" (click)="selectLanguage(lang)"
        ><span
          *ngIf="lang?.name == 'English'"
          class="accessibility-plugin-ac"
          style="display: block"
          >{{ lang?.regional }}</span
        ><span
          *ngIf="lang?.name != 'English'"
          class="accessibility-plugin-ac"
          style="display: block"
          >{{ lang?.regional }}({{ lang?.name }})</span
        >
      </mat-option></mat-select
    ></mat-form-field
  >
</div>
